export default "__VITE_PUBLIC_ASSET__69ad6d66__"